import React from 'react';
import PageHero from '../../../components/page/PageHero';
import { useTheme } from '../../../shared/ThemeContext';



function ThemeSwatch({ option, isSelected, onSelect }) {
  return (
    <button
      aria-pressed={isSelected}
      className={`theme-swatch-card${isSelected ? ' theme-swatch-card--selected' : ''}`}
      onClick={() => onSelect(option.id)}
      type="button"
    >
      <div className="theme-swatch-palette" aria-hidden="true">
        {option.swatches.map((color, index) => (
          <span
            className="theme-swatch-dot"
            key={index}
            style={{ background: color }}
          />
        ))}
      </div>
      <div className="theme-swatch-info">
        <strong className="theme-swatch-label">{option.label}</strong>
        {isSelected && <span className="theme-swatch-active-badge">Active</span>}
      </div>
      <p className="theme-swatch-description">{option.description}</p>
    </button>
  );
}

const Component = () => {
  const { themeId, setThemeId, options } = useTheme();

  return (
    <div className="stack">
      <PageHero
        subtitle="Customize your workspace preferences."
        title="Settings"
      />

      <section className="card stack-sm">
        <h3 className="section-title">Theme</h3>
        <p className="settings-help-text">Choose how your workspace looks. Your preference is saved and synced across devices.</p>
        <div className="theme-swatch-grid">
          {options.map((option) => (
            <ThemeSwatch
              isSelected={themeId === option.id}
              key={option.id}
              onSelect={setThemeId}
              option={option}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Component;
